import fiat from '#src/assets/icons/fiat.webp';
import { unitMapping } from '#src/lib/style.ts';

export const Fiat = ({
  size = 2,
  className,
}: {
  size?: keyof typeof unitMapping;
  className?: string;
}) => (
  <img
    className={className}
    style={{ width: unitMapping[size], height: unitMapping[size] }}
    src={fiat}
    alt="Fiat"
  />
);
